import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BlobUploadCommonResponse } from '@azure/storage-blob';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { UsuarioService } from '@account/usuario.service';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { MessageService } from '@shell/message.service';
import { StockService } from '@stock/stock.service';
import { AzureBlobUploadService } from '../azure-blob-upload.service';
import { CondicionIVA } from '@shared/enums/condicionIVA';
import { TipoBlobStorage } from '@shared/enums/TipoBlobStorage';
import { CargaArchivo } from '@shared/models/cliente/CargaArchivo';
import { Aerovale } from '@shared/models/despacho/Aerovale';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Cliente } from '@shared/models/facturacion/Cliente';
import { CuponPagoTarjeta } from '@shared/models/facturacion/CuponPagoTarjeta';
import { EmitirFactura } from '@shared/models/facturacion/EmitirFactura';
import { Sas } from '@shared/models/padrones/Sas';
import { SeleccionClienteFacturacionComponent } from '../seleccion-cliente-facturacion/seleccion-cliente-facturacion.component';
import { TipoPago } from '@shared/enums/tipoPago';
import { PaymentManagerComponent } from '@shared/components/paymet-manager/payment-manager.component';
import { PagoElectronicoDto } from '@shared/models/facturacion';
import { FacturaService } from '@shared/factura.service';
import { FacturaRespuesta } from '@shared/models/facturacion/FacturaRespuesta';
import { environment } from '@environments';
import { isEmptyValue } from '@shared/compat-tools';
import { VisorComprobanteComponent } from '@shared/visor-comprobante/visor-comprobante.component';
import { Factura } from '@shared/models/facturacion/Factura';

@Component({
  selector: 'app-importe-factura',
  templateUrl: './importe-factura.component.html',
  styleUrls: ['./importe-factura.component.css']
})
export class ImporteFacturaComponent implements OnInit, OnDestroy {

  @Input() aerovaleAfacturar: Aerovale;

  calculandoImporte: boolean = false;
  facturando:boolean;
  listaAerovales:string[]=[];
  emitirFactura: EmitirFactura;
  error: string;

  // Datos para verificar si se debe identificar el cliente.
  montoMaximoElectronico: number;
  montoMaximoEfectivo: number;
  codigoAFIP: string = "";
  segundosEntreReintentos = 30;
  maximaCantidadReintentos = 3;
  reintentosRealizados = 0;
  mostrarEsperaEntreReintentosFacturacion: boolean;
  segundosRestantes: number;
  idInterval;

  mostrarMensajeFacturacionEnPruebas: boolean = false;

  importeFacturaForm = new UntypedFormGroup({
    listaCuponesFormControl: new UntypedFormControl(''),
    comentariosFormControl: new UntypedFormControl('',[Validators.required]),
    })

  cantidadArchivoSubidos: number = 0;
  private cantidadArchivoSubidos$ = new Subject<number>();
  private subscription: Subscription;
  imagenes: File[] = [];
  mensaje: string = null;
  TipoPago = TipoPago;
  points = [];

  facturaRespuesta: FacturaRespuesta;

  constructor(private messageService: MessageService,
    private modalService:NgbModal,
    public activeModal: NgbActiveModal,
    private comprobanteService: ComprobanteService,
    private spinner: NgxSpinnerService,
    private usuarioService: UsuarioService,
    private stockService: StockService,
    private azureBlobUpload: AzureBlobUploadService,
    private facturaService: FacturaService) { }

  ngOnInit() {
    this.reintentosRealizados = 0;
    this.segundosRestantes = this.segundosEntreReintentos;

    this.emitirFactura=new EmitirFactura();
    this.emitirFactura.cupones=[];
    this.emitirFactura._payment=[];
    this.listaAerovales.push(this.aerovaleAfacturar.id);
    this.obtenerImporteAFacturar();

    this.mostrarMensajeFacturacionEnPruebas = this.usuarioService.getAeroplantaActual().habilitarFacturacion && (! this.usuarioService.getAeroplantaActual().soloPAD);
    this.subscriptionUploadFile();
    this.getAllPoints();
  }

  getAllPoints() {
    this.comprobanteService.getPoints( this.usuarioService.getAeroplantaActual().codigoAeroplanta )
      .subscribe(r => {
        this.points = r.filter(p =>p.codigoAeroplanta == this.usuarioService.getAeroplantaActual().codigoAeroplanta);
      }, () => {
        this.points = [];
      }
    );
  }

  subscriptionUploadFile() {
    this.cantidadArchivoSubidos = 0;

    this.subscription = this.cantidadArchivoSubidos$.subscribe(()=>{
      this.cantidadArchivoSubidos++;
      if(this.cantidadArchivoSubidos==this.imagenes.length) {
        this.conectarConWSFacturacion();
      }
    });
  }

  modalAgregarCupon(tipoPago: TipoPago) {
    const modalRef = this.modalService.open(PaymentManagerComponent, {
      centered: true,
      backdrop: "static",
    });
    modalRef.componentInstance.listaCupones = this.emitirFactura.cupones;
    modalRef.componentInstance.importe = this.getTotalEfectivo();
    modalRef.componentInstance.paymentType = tipoPago;
    modalRef.componentInstance.facturaId = this.facturaRespuesta?.facturaId;
    modalRef.componentInstance.listaAerovales = this.listaAerovales;
    modalRef.componentInstance.points = this.points;
    modalRef.componentInstance.nuevoCupon.subscribe((result) => {
      const cupon: CuponPagoTarjeta = new CuponPagoTarjeta();
      cupon.tarjetaId = result.tarjeta.id;
      cupon.tarjeta = result.tarjeta;
      cupon.numeroCupon = Number(result.numeroCupon);
      cupon.numeroLote = Number(result.numeroLote);
      cupon.numeroTarjeta = Number(result.numeroTarjeta);
      cupon.importe = Number(result.importe);
      cupon.pathCuponFisico = result.pathCuponFisico;

      this.emitirFactura.cupones.push(cupon);
      this.imagenes.push(result._file);
    });
    modalRef.componentInstance.payment.subscribe((result) => {      
      const pago = new PagoElectronicoDto();
      pago.importe=result.importe;
      pago.tipoPago=result.tipoPago;
      pago.paymentId=result.paymentId;
      pago._alias=result._alias;
      pago._numero=result._numero;
      pago.discounts=result.discounts;

      this.emitirFactura._payment.push(pago);
    });
  }

  desasignarCupon(cupon) {
    const index: number = this.emitirFactura.cupones.indexOf(cupon);
    if (index !== -1) {
      this.emitirFactura.cupones.splice(index, 1);
      this.imagenes.splice(index, 1); // check delete file
    }
  }

  mostrarSpinner() {
    this.calculandoImporte = true;
    this.spinner.show('spinnerImporteFactura');
  }

  ocultarSpinner() {
    this.calculandoImporte = false;
    this.spinner.hide('spinnerImporteFactura');
  }

  obtenerImporteAFacturar()
  {    
    this.mostrarSpinner();
    this.comprobanteService.obtenerImporteAFacturar(this.listaAerovales)
      .subscribe(result => {
          if (result) {
            this.facturaRespuesta = result;
            this.maximaCantidadReintentos = result.afipCantidadIntentosCAEA;
            this.segundosEntreReintentos = result.afipTiempoReintentoCAEA;
            this.montoMaximoElectronico = result.montoMaximoPagoElectronico;
            this.montoMaximoEfectivo = result.montoMaximoPagoContado;
            this.codigoAFIP = result.condicionIVA?.codigoAFIP;
            this.ocultarSpinner();
          }
        }, (err: ErrorModel) => {
          this.ocultarSpinner();
          this.messageService.showErrorMessage(err.message + " " + err.description);
          this.activeModal.close();
        } );
  }


  facturar()
  {
    if(this.seRequiereFacturarClienteEspecifico(this.paymentInProgress, this.facturaRespuesta?.total)){
      // Se muestra modal para identificar cliente.
      // Al volver el cliente, se llama a facturar agregando el cliente a emitirFactura.
      // Si no se identifica al cliente, no se asigna cliente en emitirFactura.
      const modalRef = this.modalService.open(SeleccionClienteFacturacionComponent, { centered: true, backdrop: 'static' });
      modalRef.result.then((cliente: Cliente) => {
        if(cliente){
          this.emitirFactura.cliente = cliente;
          this.prepararFaturacion();
        }
      });
    }else{
      this.prepararFaturacion();
    }
  }

  prepararFaturacion() {        
    if(this.imagenes.length>0) {
      const i=0;
      this.uploadFileBlobStorage(this.imagenes[i], i);
    } else {
      this.conectarConWSFacturacion();
    }
  }

  uploadFileBlobStorage(file: File, i: number) {    
    this.mensaje = `Subiendo ${i++} archivo...`;
    const carga: CargaArchivo = new CargaArchivo(file.name);
    this.stockService.obtenerSas(TipoBlobStorage.files, false).subscribe((sas: Sas) => {
    const aborter = this.azureBlobUpload.uploadFileToBlobStorage(file, sas.containerUri, sas.sas,
      (pro) => {
        carga.progress = pro;
      },
      (val: BlobUploadCommonResponse) => {
        if (val) {
          carga.progress = 100;
          this.cantidadArchivoSubidos$.next();
          i++;
          if(this.imagenes[i]!=undefined) {
            this.uploadFileBlobStorage(this.imagenes[i], i);
          }        
        }
      });  
      carga.setAborter(aborter);            
    }, ()=> {
      this.messageService.showErrorMessage("Error al obtener el SAS del blob storage.");
      this.mensaje = null;
    }); 
  }

  conectarConWSFacturacion(){
    this.mensaje = `Generando factura...`;
    this.subscription.unsubscribe();
    this.facturando=true;
    this.error = null;

    this.emitirFactura.observaciones = this.comentariosFormControl.value;
    this.comprobanteService.facturar(this.facturaRespuesta?.facturaId, this.emitirFactura)
      .subscribe(result => {
        this.facturando=false;
        this.mensaje = null;
        this.messageService.showSuccessMessage("Se facturo el aerovale correctamente.");
        //this.visorAerovales.ngOnInit();
        this.visorFactura(result);
      }, (err: ErrorModel) => {

        this.facturando=false;
        this.mensaje = null;
        if(err.code == "50201"){
          if(this.reintentosRealizados < this.maximaCantidadReintentos){
            this.mostrarEsperaEntreReintentosFacturacion = true;

            this.idInterval = setInterval(() => {
              this.segundosRestantes--; 
            }, 1000);

            setTimeout(()=>{
              this.reintentosRealizados++;
              this.mostrarEsperaEntreReintentosFacturacion = false;              
              clearInterval(this.idInterval);
              this.segundosRestantes = this.segundosEntreReintentos;
              this.conectarConWSFacturacion();
            }, this.segundosEntreReintentos * 1000);
            return;
          }
        }

        this.error = err.message + " " + err.description;

      });
  }

  visorFactura(factura: Factura) {
    this.comprobanteService.obtenerComprobantePorId(factura.id).subscribe(c => {
      const modalRef = this.modalService.open(VisorComprobanteComponent, { centered: true, size: 'lg' });
      modalRef.componentInstance.facturaObtenida = c;
      modalRef.componentInstance.mostrarPanelBotones = true;
      modalRef.result.finally(()=> {
        this.activeModal.close('FACTURADO')
      });
    })
  }

  seRequiereFacturarClienteEspecifico(paymentCheck: boolean, importeTotal: number){

    if(this.aerovaleAfacturar.cliente.numeroCuenta == this.facturaRespuesta?.ctaSgc_ClienteCF){
        if(paymentCheck){
            if(this.montoMaximoElectronico == 0){
                return false;
            }

            if(importeTotal > this.montoMaximoElectronico){
                return true;
            }
        }else{
            if(this.montoMaximoEfectivo == 0){
                return false;
            }

            if(importeTotal > this.montoMaximoEfectivo){
                return true;
            }
        }
    }

    return false;
  }



  // utils

  getNumeroOperacion(paymentId: string) {
    try {
      const numberString = paymentId?.split('.');
      return '#'.concat(numberString[0]);
    } catch (error) {
      return '';
    }
    
  }

  getTotalEfectivo() {
    let total: number = 0;
    // const totalFactura = this.importeTotal;
    const totalFactura = this.facturaRespuesta?.total;
    const totalPago = this.facturaService.calcularTotalCupones(this.emitirFactura.cupones);
    const totalPagoElectronicos = this.facturaService.calcularTotalPagosElectronicos(this.emitirFactura._payment);
    //const totalDescuentoPagoElectronico = this.facturaService.calcularTotalDescuentosPagosElectronicos(this.emitirFactura._payment);
    total = totalFactura - totalPago - totalPagoElectronicos;

    if (total < 0){
      total = 0;
    }

    return total;
  }

  obtenerCondicionIVA(c:number):string
  {
    return CondicionIVA[c];
  }

  ngOnDestroy() {
    if (this.idInterval) {
      clearInterval(this.idInterval);
    }
  }

  getTipoPago(tipo: number) {
    return TipoPago[tipo].toUpperCase();
  }

  onClose() {
    if (this.paymentInSuccess) {
      this.messageService.showErrorMessage("No puede cancelar la operación porque hay un pago electrónico imputado, debe generar la factura")
      return;
    } 

    this.activeModal.close()
  }

  get inProduction(): boolean {
    return environment.name === 'production';
  }

  get configuracionPagosElectronicos() : boolean {
    return !isEmptyValue(this.usuarioService.getAeroplantaActual().legacySiteId);
  }

  // getters

  get comentariosFormControl() {
    return this.importeFacturaForm.get('comentariosFormControl');
  }

  get totalPagoTarjeta(): number {
    return this.facturaService.calcularTotalCupones(this.emitirFactura.cupones);
  }

  get totalPagoEectronico(): number {
    return this.facturaService.calcularTotalPagosElectronicos(this.emitirFactura._payment);
  }

  get totalDescuentoPagoEletronico(): number {
    return this.facturaService.calcularTotalDescuentosPagosElectronicos(this.emitirFactura._payment);
  }

  get paymentInSuccess(): boolean {
    return this.totalPagoEectronico > 0;
  }

  get paymentInDiscount(): boolean {
    return this.totalDescuentoPagoEletronico > 0;
  }

  get paymentInProgress(): boolean {
    return this.totalPagoTarjeta > 0 || this.totalPagoEectronico > 0;
  }

  get deshabilitarPagosConAppYpf(): boolean {
    return this.codigoAFIP !== '05';
  }

  get deshabilitarPagoConPointSmart(): boolean {
    return this.points?.length == 0;
  }
}

